"use client";

import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useAuth } from "@/components/providers/auth-context";
import useAuthModal from "@/features/auth/hooks/use-auth-modal";
import { useTRPC } from "@/trpc/client";

export const OnboardingGuard = () => {
  const { userId } = useAuth();
  const trpc = useTRPC();
  const { onOpen } = useAuthModal();
  const [hasTriggered, setHasTriggered] = useState(false);

  const userQuery = trpc.users.me.queryOptions();
  const { data } = useQuery({
    ...userQuery,
    enabled: Boolean(userId),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!userId || !data) {
      setHasTriggered(false);
      return;
    }

    const onboardedSteps = data.onboardedSteps ?? 0;

    if (onboardedSteps < 2 && !hasTriggered) {
      onOpen("onboarding");
      setHasTriggered(true);
    }

    if (onboardedSteps >= 2 && hasTriggered) {
      setHasTriggered(false);
    }
  }, [data, hasTriggered, onOpen, userId]);

  return null;
};
